import { render, staticRenderFns } from "./SortableList.vue?vue&type=template&id=594a308a&lang=pug"
import script from "./SortableList.vue?vue&type=script&lang=js"
export * from "./SortableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports